import { combineReducers } from 'redux';

import paymentInformationsReducer from './paymentInformations';

export const SHOP_STATE_KEY = 'shop';

export default combineReducers({
  paymentInformations: paymentInformationsReducer,
});
